import { useState } from "react";
import { api, errDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Pulse, EnvelopeSimple } from "@phosphor-icons/react";

export default function Login() {
  const { login, config } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    setNotice("");
    try {
      const { data } = await api.post(`/auth/${mode}`, { email, password });
      if (data.activation_required) {
        setNotice(data.message);
        setMode("login");
      } else {
        login(data.token, data.user);
      }
    } catch (err) {
      setError(errDetail(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <form onSubmit={submit} className="w-full max-w-sm border border-border bg-card p-8 space-y-5" data-testid="login-form">
        <div className="flex items-center gap-2">
          <Pulse size={26} weight="bold" className="text-primary" />
          <h1 className="font-heading font-bold text-2xl tracking-tight">My trading journal</h1>
        </div>
        <p className="text-sm text-muted-foreground">
          {mode === "login" ? "Sign in to your journal" : "Create your account"}
        </p>
        <div>
          <Label className="label-caps text-muted-foreground">{mode === "login" ? "Email / username" : "Email"}</Label>
          <Input data-testid="login-email-input" type={mode === "login" ? "text" : "email"} required value={email}
            onChange={(e) => setEmail(e.target.value)} className="mt-1" autoComplete="username" />
        </div>
        <div>
          <Label className="label-caps text-muted-foreground">Password</Label>
          <Input data-testid="login-password-input" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)} className="mt-1" />
        </div>
        {error && <p className="text-sm text-loss" data-testid="login-error">{error}</p>}
        {notice && (
          <p className="text-sm text-profit flex items-start gap-2" data-testid="login-notice">
            <EnvelopeSimple size={16} weight="bold" className="mt-0.5 shrink-0" /> {notice}
          </p>
        )}
        <Button data-testid="login-submit-btn" type="submit" disabled={busy}
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground">
          {busy ? "Please wait…" : mode === "login" ? "Sign In" : "Sign Up"}
        </Button>
        {config?.allow_registration && (
          <button type="button" data-testid="login-toggle-mode-btn"
            onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); setNotice(""); }}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150 w-full text-center">
            {mode === "login" ? "No account? Sign up" : "Have an account? Sign in"}
          </button>
        )}
      </form>
    </div>
  );
}
